/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { GoogleApiLoader } from './google-api-loader.service';
import { ExternalGoogleConfig, GOOGLE_CONFIG, GoogleAuthService } from './google-auth.service';
import { GoogleChartsLoader } from './google-charts-loader.service';

@NgModule({
  providers: [],
})
export class CoreExternalGoogleModule {
  static forRoot(config: ExternalGoogleConfig): ModuleWithProviders<any> {
    return {
      ngModule: CoreExternalGoogleModule,
      providers: [
        GoogleApiLoader,
        GoogleChartsLoader,
        GoogleAuthService,
        { provide: GOOGLE_CONFIG, useValue: config },
      ],
    };
  }
}
